<div class="page_wrapper">
  <app-header-new></app-header-new>

  <div class="container-fluid wrapper-page header-fix position-relative display-contents" *ngIf="!consultationReport">
    <div align="center">
      <h2 class="mt-4 mb-4 text-color font-size-25 font-weight-500 text-uppercase">
        Your Appointment Summary
      </h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                <form [formGroup]="aptForm">
                  <div class="row align-items-center mb-3">
                    <div class="col-md-6 text-right">
                      <label for="aptid" class="font-size-25 font-weight-bold">Appointment ID</label>
                    </div>
                    <div class="col-md-6">
                      <input type="text" class="form-control" placeholder="Appointment ID" formControlName="aptid"
                        id="aptid" readonly />
                      <div *ngIf="aptForm.get('aptid').hasError('required')" class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-md-6 text-right">
                      <label for="passcode" class="font-size-25 font-weight-bold">Passcode</label>
                    </div>
                    <div class="col-md-6">
                      <input type="password" class="form-control" placeholder="Passcode" formControlName="passcode"
                        id="passcode" />
                      <div *ngIf="aptForm.get('passcode').hasError('required')" class="invalid-feedback">
                        This is required
                      </div>
                    </div>
                  </div>

                  <div class="row align-items-center">
                    <div class="col-md-12 text-center">
                      <button class="btn btn-primary" [disabled]="aptForm.invalid" (click)="submit()">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid wrapper-page header-fix position-relative display-contents" *ngIf="consultationReport">
    <div align="center">
      <h2 class="mt-2 mb-4 text-color font-size-25 font-weight-500 mt-4">
        CONSULTATION REPORT
      </h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="bg-primary text-white p-3">
          <h5 class="mt-2 ml-3">
            APPOINTMENT ID: {{ consultationReport?.aptid }}
          </h5>
        </div>
        <br />
        <div class="bg-primary text-white p-1">
          <h5 class="mt-2 ml-4">YOUR CONSULTING DOCTOR</h5>
        </div>
        <div class="card m-b-30">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-3">
                <div class="card border-0 m-b-30">
                  <form>
                    <img [src]="physician?.ppurl" class="rounded-circle w-100 h-100" />
                  </form>
                </div>
              </div>
              <div class="col-md-6 detail-tbl">
                <h3 class="text-color font-size-20 text-capitalize">
                  {{ physician?.title ? physician?.title : defaultDr }}
                  {{ physician?.first_name }} {{ physician?.last_name }}
                  {{ physician?.qualification }}
                </h3>
                <table class="table">
                  <tbody>
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Speciality
                      </td>
                      <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician_model?.speciality }}
                      </td>
                    </tr>

                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        University
                      </td>
                      <td class="text-change font-size-16 font-weight-500 border-0">
                        {{ physician_model?.university }}
                      </td>
                    </tr>

                    <!--<tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">Education</td>
                      <td class="text-change  font-size-16 font-weight-500 text-capitalize border-0">
                        {{physician_model?.education}} </td>
                    </tr> -->
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Location
                      </td>
                      <td class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician?.city }}{{ physician_model?.location }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-color-font font-size-16 pl-0 border-0">
                        Registration No.
                      </td>
                      <td *ngIf="
                          physician &&
                          physician.physician_qualification &&
                          physician.physician_qualification.length > 0
                        " class="text-change font-size-16 font-weight-500 text-capitalize border-0">
                        {{ physician.physician_qualification[0]?.r_no }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-primary text-white p-1">
          <h5 class="mt-2 ml-4">CONSULTATION SUMMARY</h5>
        </div>
        <div class="card m-b-30">
          <div class="card-body" style="white-space:pre-wrap">
            <p>{{ consultationReport?.consultation?.summary }}</p>
          </div>
        </div>
        <div *ngIf="prescription">
          <div class="bg-primary text-white p-1">
            <h5 class="mt-2 ml-4">
              PRESCRIPTION DETAILS
              <a href="{{ consultationReport?.p_url }}" *ngIf="consultationReport?.p_url" class="text-white"
                title="Download Prescription"><i class="fa fa-download float-right mr-2" aria-hidden="true"></i></a>
            </h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body table-responsive">
              <div class="row">
                <div class="col-md-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">Drug Name</th>
                        <th scope="col">Strength</th>
                        <th scope="col">Frequency</th>
                        <th scope="col">Medicine Intake</th>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col">Additional Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let presc of prescription">
                        <td>{{ presc?.mname }}</td>
                        <td>{{ presc?.strength }}</td>
                        <td>{{ presc?.intakefreq }}</td>
                        <td>{{ presc?.intake }}</td>
                        <td>{{ presc?.sdate | date: dateFormat }}</td>
                        <td>{{ presc?.edate | date: dateFormat }}</td>
                        <td>{{ presc?.remarks }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <button type="button" class="btn btn-primary btn-lg pl-5 pr-5" (click)="gotoPage()">
        PROVIDE FEEDBACK
      </button>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>